import React from "react";

import { Button } from "@/components/ui/button";
import { useNavigate } from "@tanstack/react-router";

const DiscoveryFooter: React.FC = () => {
	const navigate = useNavigate();
	return (
		<footer className="border-t bg-[#2A2A2A] border-gray-800 text-white">
			<div className="px-6 py-12">
				<div className="mx-auto max-w-7xl">
					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
						{/* Company Info */}
						<div className="lg:col-span-1">
							<div className="flex items-center mb-4">
								<Button
									variant="ghost"
									className="p-0 rounded-none hover:bg-transparent focus:bg-transparent"
									onClick={() => {
										navigate({ to: "/" });
										window.scrollTo({ top: 0, behavior: "auto" });
									}}
								>
									<img
										src="/logo-with-color.png"
										className="w-48"
										alt="Platform Logo"
									/>
								</Button>
							</div>
							<p className="text-gray-400 text-sm leading-relaxed">
								Connect businesses with verified vendors for secure and
								reliable transactions worldwide.
							</p>
						</div>

						{/* Quick Links */}
						<div>
							<h3 className="text-lg font-semibold mb-4">Quick Links</h3>
							<ul className="space-y-3">
								<li>
									<Button asChild variant="link" className="text-gray-400 hover:text-white transition-colors p-0 h-auto">
										<a href="/">Home</a>
									</Button>
								</li>
								<li>
									<Button asChild variant="link" className="text-gray-400 hover:text-white transition-colors p-0 h-auto">
										<a href="/features">Features</a>
									</Button>
								</li>
							</ul>
						</div>

						{/* Legal */}
						<div>
							<h3 className="text-lg font-semibold mb-4">Legal</h3>
							<ul className="space-y-3">
								<li>
									<Button asChild variant="link" className="text-gray-400 hover:text-white transition-colors p-0 h-auto">
										<a href="/privacy">Privacy Policy</a>
									</Button>
								</li>
								<li>
									<Button asChild variant="link" className="text-gray-400 hover:text-white transition-colors p-0 h-auto">
										<a href="/terms">Terms of Service</a>
									</Button>
								</li>
							</ul>
						</div>

						{/* Contact Us */}
						<div>
							<h3 className="text-lg font-semibold mb-4">Contact Us</h3>
							<div className="space-y-3 text-gray-400">
								<p>info@intasida.com</p>
								<p>markanthony@intasida.com</p>
								<p>+234 814 222 4513</p>
								<p>12 Mrs. Pelizer Ogar street, Indepence layout, Enugu state.</p>
							</div>
						</div>
					</div>

					{/* Bottom Section */}
					<div className="flex flex-col md:flex-row justify-between items-center mt-12 pt-8 border-t border-gray-800">
						<p className="text-gray-400 text-sm mb-4 md:mb-0">
							@2025 Secure vendor connect. All rights reserved.
						</p>
						<div className="flex space-x-4">
							<Button asChild variant="ghost" className="text-gray-400 hover:text-white transition-colors p-0 h-auto">
								<a href="https://www.instagram.com/official_intasida?igsh=M3c1cjE1c29mbTc5" target="_blank" rel="noreferrer noopener">
									<svg className="size-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<rect width="20" height="20" x="2" y="2" rx="5" />
										<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" />
										<line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
									</svg>
								</a>
							</Button>
							<Button asChild variant="ghost" className="text-gray-400 hover:text-white transition-colors p-0 h-auto">
								<a href="#">
									<svg className="size-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 2h-3a4 4 0 0 0-4 4v3H6v4h5v8h4v-8h3l1-4h-4V6a1 1 0 0 1 1-1h3z" /></svg>
								</a>
							</Button>
							<Button asChild variant="ghost" className="text-gray-400 hover:text-white transition-colors p-0 h-auto">
								<a href="https://x.com/official_intasida" target="_blank" rel="noreferrer noopener">
									<svg className="size-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9.09 9.09 0 0 1-2.88 1.1A4.52 4.52 0 0 0 16.11 0c-2.5 0-4.52 2.02-4.52 4.52 0 .35.04.7.11 1.03C7.69 5.4 4.07 3.6 1.64.96c-.38.65-.6 1.4-.6 2.2 0 1.52.77 2.86 1.94 3.64A4.48 4.48 0 0 1 .96 6v.06c0 2.13 1.52 3.91 3.54 4.31-.37.1-.76.16-1.16.16-.28 0-.55-.03-.81-.08.55 1.72 2.16 2.97 4.07 3A9.05 9.05 0 0 1 0 19.54a12.8 12.8 0 0 0 6.92 2.03c8.3 0 12.84-6.87 12.84-12.84 0-.2 0-.39-.01-.58A9.22 9.22 0 0 0 24 4.59a9.1 9.1 0 0 1-2.6.71A4.52 4.52 0 0 0 23 3Z" /></svg>
								</a>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default DiscoveryFooter;
